import { COLOR_PURPLE_BASE } from '@alltrails/denali/tokens';
import { createCircleMarker, getCircleMarkerSize } from './svgMarkerComponents';

const innerDiameter = 16;
export const svgSize = getCircleMarkerSize(innerDiameter);
const photospotSvg = createCircleMarker({ imageName: 'photospot-image', innerDiameter, innerFill: COLOR_PURPLE_BASE });

export default photospotSvg;
